export const CATERING_AGENT_TYPE = 'CateringAgent'
const CATERING_AGENT_LABEL = 'Catering Agent'

export const AGENT_TYPE_OPTIONS = [
  { name: 'Upsell Agent', value: 'UpsellAgent' },
  { name: 'Winback Agent', value: 'WinbackAgent' },
  { name: 'Abandon Cart Agent', value: 'AbandonCartAgent' },
  { name: 'Reviews Agent', value: 'ReviewAgent' }
]

export const CATERING_AGENT_TYPE_OPTIONS = [{ name: CATERING_AGENT_LABEL, value: CATERING_AGENT_TYPE }]

export const DEFAULT_AGENT_TYPE = 'UpsellAgent'

export const AGENTS_REQUEST = 'agents?included=agent_playbook,agent_playbook.agent_playbook_steps'

export const agentTypeLabel = type => AGENT_TYPE_OPTIONS.find(option => option.value === type)?.name

// "Store - Type" for a store-bound agent, just the type for a merchant-wide one.
export const agentLabel = (agent, playbook) => {
  const typeLabel = agentTypeLabel(agent?.attributes?.type) || 'Agent'
  const storeName = playbook?.attributes?.store_name
  return storeName ? `${storeName} - ${typeLabel}` : typeLabel
}

// Agents that reach out to customers on their own. Saving one of these shows the
// impact warning, and the API caps each at this many messages a day.
export const PROACTIVE_AGENT_TYPES = ['UpsellAgent', 'WinbackAgent', 'AbandonCartAgent', 'ReviewAgent']
export const AGENT_DAILY_SEND_CAP = 50

// Preselect the agent type from a ?type= query param when it's a known type; otherwise use the default.
export function resolveInitialAgentType(queryType) {
  const isValid = AGENT_TYPE_OPTIONS.some(option => option.value === queryType)
  return isValid ? queryType : DEFAULT_AGENT_TYPE
}

export const isCateringAgent = agent => agent?.attributes?.type === CATERING_AGENT_TYPE

export const withoutCateringAgents = agents => agents.filter(agent => !isCateringAgent(agent))

export function pickCateringAgent(agents) {
  const newestFirst = agents.filter(isCateringAgent).sort((a, b) => Number(b.id) - Number(a.id))
  return newestFirst.find(agent => agent.attributes.is_active) || newestFirst[0] || null
}

export const cateringAgentTitle = storeName =>
  storeName ? `${storeName} - ${CATERING_AGENT_LABEL}` : CATERING_AGENT_LABEL
